import { render, staticRenderFns } from "./OtherPayment.vue?vue&type=template&id=65389cf4&scoped=true"
import script from "./OtherPayment.vue?vue&type=script&lang=js"
export * from "./OtherPayment.vue?vue&type=script&lang=js"
import style0 from "./OtherPayment.vue?vue&type=style&index=0&id=65389cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65389cf4",
  null
  
)

export default component.exports